export default {
    API: {
        PARTICIPANTS: {
            /** GET */
            BY_STATUS: 'stats/event/{eventId}/participants/status'
        }
    }
};
